import client from "../client/client";

class SppRequirementService {
	getDeliverablesForRequirement({ projectId, requirementId }, cancelToken) {
		return client.get(`/spp/projects/${projectId}/requirements/${requirementId}/coverage-document`, {
			config: { cancelToken },
		});
	}

	getParagraphsOfDeliverable({ projectId, requirementId, deliverableId }, cancelToken) {
		return client.get(
			`/spp/projects/${projectId}/requirements/${requirementId}/coverage-document/${deliverableId}`,
			{
				config: { cancelToken },
			}
		);
	}

	getParagraphOutAttributes({ projectId, requirementId, paragraphOutId }, cancelToken) {
		return client.get(
			`/spp/projects/${projectId}/requirements/${requirementId}/paragraphOut/${paragraphOutId}/attributes`,
			{
				config: { cancelToken },
			}
		);
	}

	updateParagraphOutAttributes({ projectId, requirementId, paragraphOutId }, { attributes }, cancelToken) {
		return client.post(
			`/spp/projects/${projectId}/requirements/${requirementId}/paragraphOut/${paragraphOutId}/attributes`,
			{
				payload: { attributes },
				config: { cancelToken },
			}
		);
	}

	getParagraphsOfDeliverableByProjectFiltered({ projectId }, { page = 0, limit = 25 }, { filters }, cancelToken) {
		return client.post(`/spp/projects/${projectId}`, {
			params: { page, limit },
			payload: filters,
			config: { cancelToken },
		});
	}

	getProjectDeliverablesWithChildrenRequirementsCount(
		{ projectId },
		{ page = 0, limit = 25 },
		{ filters },
		cancelToken
	) {
		return client.post(`/spp/deliverables/projects/${projectId}`, {
			params: { page, limit },
			payload: filters,
			config: { cancelToken },
		});
	}
}

export default new SppRequirementService();
